// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"32a7def1","171":"6dde6c9e","455":"634c8d39","472":"f3cd9336","589":"27b17547","666":"4fed142c","871":"8318bafd"}[chunkId] + ".chunk.js";
};